require('./RAHireManagementPlanStep1.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @commons
const RAInput = require('../../commons/RAInput/RAInput');
const OKPillSelectors = require('components/commons/OKPillSelectors/OKPillSelectors');
const { OKMessage } = require('commonsComponents/OKMessage');
const RAOneLineSymbolAmount = require('../../commons/RAOneLineSymbolAmount/RAOneLineSymbolAmount');
const { OKLink } = require('commonsComponents/OKLink');
const OKModal = require('components/commons/OKModal/OKModal');

// @components
const RACommissionTag = require('../../RACommissionTag/RACommissionTag');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const RAHireFundTable = require('../../commons/RAHireFundTable/RAHireFundTable');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const WebappRender = require('components/conditionalRender/webappRender');

// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
const {
    formatWithoutRoundedPercentage,
} = require('../../../utilities/RACurrencyHelper');
const {
    formatAmount,
    getFormattedString,
} = require('utilities/currencyHelper');
const { recordProcess } = require('utilities/tagging');

// @constants
const {
    EURO_SYMBOL,
    FIRST_STEP,
    PERCENTAGE_SYMBOL,
} = require('constants/index');
const {
    PROC_RA_CLOSE,
    PROC_RA_UNDERSTOOD,
    PROC_RA_VIEW,
    RA_INVESTMENT_TYPE_FOUNDS,
    RA_INVESTMENT_TYPE_MONEY,
    MAXIMUM_MANAGEMENT_PLAN_INVESTMENT_AMOUNT,
    MINIMUM_FUND_AMOUNT,
} = require('../../../raConstants/index');

const explicitCostValue1 = {
    value1: '0,85',
    value2: '1,03',
};
const explicitCostValue2 = {
    value1: '0,65',
    value2: '0,79',
};
const explicitCostValue3 = {
    value1: '0,55',
    value2: '0,67',
};
const explicitCostValue4 = {
    value1: '0,45',
    value2: '0,54',
};
const explicitCostValue5 = {
    value1: '0,35',
    value2: '0,42',
};

class RAHireManagementPlanStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isServiceCostsModalOpen: false,
            isTransferFundsModalOpen: false,
        };
        this.handleServiceCostsModalConfirm = this.handleServiceCostsModalConfirm.bind(
            this,
        );
        this.handleServiceCostsModalToogle = this.handleServiceCostsModalToogle.bind(
            this,
        );
        this.handleTransferFundsMoreInfoModalToogle = this.handleTransferFundsMoreInfoModalToogle.bind(
            this,
        );
    }

    componentDidMount() {
        const customData = {
            pageName: '/contractingRobo/step1/investmentDetails',
            sectionFamily: 'wealth',
            sectionCategory: 'products',
            sectionName: 'robo',
            serviceType: 'productContracting',
            interactionType: 'funnel',
            processType: 'contractingRobo',
            processStep: `step1`,
            processDetail: 'investmentDetails',
            productName: 'robo',
        };
        recordProcess('', '', customData, true);
    }

    calculateValue() {
        const anualCostPercentage = formatAmount(
            formatWithoutRoundedPercentage(this.props.annualCost, false, true),
        );
        const percentage = `${anualCostPercentage} ${PERCENTAGE_SYMBOL}`;
        return percentage;
    }

    getCostItems() {
        return [
            {
                name: formatText('raHireManagementPlanStep1-anualServiceCost'),
                percentage: this.calculateValue(),
            },
        ];
    }

    handleChangeInvestmentType = value => {
        const {
            changeInvestmentType,
            handleGetExplicitImplicitCosts,
            immSteps,
            onInvestmentTypeChange,
        } = this.props;
        onInvestmentTypeChange(value);
        changeInvestmentType(value);
        if (
            immSteps.getIn([FIRST_STEP, 'investmentType']) !=
            RA_INVESTMENT_TYPE_MONEY
        )
            handleGetExplicitImplicitCosts(
                immSteps.getIn([FIRST_STEP, 'investmentAmount']),
            );
    };

    buildAmountSection(amount, active) {
        const sectionClassName = classnames(
            'ra-hire-management-plan-step1__section-amount',
            {
                'ra-hire-management-plan-step1__section-amount--active': active,
            },
        );
        const currencyClassName = classnames(
            'ra-hire-management-plan-step1__currency',
            {
                'ra-hire-management-plan-step1__currency--active': active,
            },
        );
        let customSection;

        if (active) {
            customSection = (
                <RAInput
                    amount={this.props.immSteps.getIn([
                        FIRST_STEP,
                        'investmentAmount',
                    ])}
                    customClassName="ra-hire-management-plan-step1__input"
                    onhandleChange={this.props.onInvestmentAmountChange} // eslint-disable-line
                    max={MAXIMUM_MANAGEMENT_PLAN_INVESTMENT_AMOUNT}
                    maxBackEndFractionLength={2}
                    error={this.props.immSteps.getIn([
                        FIRST_STEP,
                        'errorFlags',
                    ])}
                    errorMsg={formatText(
                        'raHireManagementPlanStep1-errorMessage',
                    )}
                />
            );
        } else {
            customSection = (
                <span className="ra-hire-management-plan-step1__amount">
                    {formatAmount(amount)}
                </span>
            );
        }

        return (
            <div className={sectionClassName}>
                {customSection}
                <span className={currencyClassName}>{EURO_SYMBOL}</span>
            </div>
        );
    }

    buildServiceCostList(tooltip = false) {
        const {
            commisionCondition,
            productCost,
            showImplicitCost,
        } = this.props;
        const customTextClassName = classnames(
            'ra-hire-management-plan-step1__text',
            'ra-hire-management-plan-step1__text--grey',
            {
                'ra-hire-management-plan-step1__text--tooltip': tooltip,
            },
        );
        const serviceCostItem = this.getCostItems();
        let commisionConditionEL;
        if (commisionCondition) {
            commisionConditionEL = (
                <div className="col-md-10">
                    <div className="ra-hire-management-plan-step1__commission-tag">
                        <RACommissionTag showZeroPercentage={true} />
                    </div>
                </div>
            );
        }
        const percentageClass = classnames(
            'ra-hire-management-plan-step1__text',
            'ra-hire-management-plan-step1__text--grey',
            {
                'ra-hire-management-plan-step1__percentage': commisionCondition,
                'ra-hire-management-plan-step1__zeroCommision': !commisionCondition,
            },
        );
        const productCostPercentage = `${formatAmount(
            formatWithoutRoundedPercentage(productCost, false, true),
        )} ${PERCENTAGE_SYMBOL}`;

        const serviceCostItemsBlock = showImplicitCost ? (
            <React.Fragment>
                <div className="ra-hire-management-plan-step1__cost-item">
                    <div className="ra-hire-management-plan-step1__text--strong-grey ra-hire-management-plan-step1__cost-item-label">
                        <FormattedText value="raHireManagementPlanStep1-servicesCost" />
                    </div>
                    <div className="ra-hire-management-plan-step1__text--grey ra-hire-management-plan-step1__cost-item-value">
                        <FormattedText
                            value="raHireManagementPlanStep1-additionalVat"
                            injectedStrings={[this.calculateValue()]}
                        />
                    </div>
                </div>
                <div className="ra-hire-management-plan-step1__cost-item">
                    <div className="ra-hire-management-plan-step1__text--strong-grey ra-hire-management-plan-step1__cost-item-label">
                        <FormattedText value="raHireManagementPlanStep1-implicitFundCosts" />
                    </div>
                    <div className="ra-hire-management-plan-step1__text--grey ra-hire-management-plan-step1__cost-item-value">
                        <FormattedText
                            value="raHireManagementPlanStep1-additionalVat"
                            injectedStrings={[productCostPercentage]}
                        />
                    </div>
                </div>

                <OKLink
                    onClick={this.handleServiceCostsModalToogle}
                    modifier="emphasize"
                >
                    <FormattedText value="raHireManagementPlanStep1-moreInformationModal" />
                </OKLink>
            </React.Fragment>
        ) : (
            serviceCostItem.map((item, index) => (
                <React.Fragment key={index}>
                    <div
                        className="row ra-hire-management-plan-step1__list-item"
                        key={index}
                    >
                        <div className="col-md-10 print-label ra-hire-management-plan-step1__print-title">
                            <OKLink
                                modifier="inherit-styles"
                                onClick={this.handleServiceCostsModalToogle}
                            >
                                <span
                                    className={`
                                        ${customTextClassName}
                                        ra-hire-management-plan-step1__text--link
                                    `}
                                >
                                    {item.name}
                                </span>
                            </OKLink>
                        </div>
                        <WebappRender>
                            <div className="col-md-auto">
                                <span className={percentageClass}>
                                    <FormattedText
                                        value="raHireManagementPlanStep1-additionalVat"
                                        injectedStrings={[item.percentage]}
                                    />
                                </span>
                            </div>
                        </WebappRender>
                        <ContactCenterRender>
                            <div className="col-md-3">
                                <span className="ra-hire-management-plan-step1__text">
                                    <FormattedText
                                        value="raHireManagementPlanStep1-additionalVat"
                                        injectedStrings={[item.percentage]}
                                    />
                                </span>
                            </div>
                        </ContactCenterRender>
                    </div>
                    <div className="row">{commisionConditionEL}</div>
                </React.Fragment>
            ))
        );

        return serviceCostItemsBlock;
    }

    handleServiceCostsModalConfirm() {
        const { onServiceCostsModalChange } = this.props;
        onServiceCostsModalChange(PROC_RA_UNDERSTOOD);
        this.setState({
            isServiceCostsModalOpen: !this.state.isServiceCostsModalOpen,
        });
    }

    handleServiceCostsModalToogle() {
        const { onServiceCostsModalChange } = this.props;
        const event = this.state.isServiceCostsModalOpen
            ? PROC_RA_CLOSE
            : PROC_RA_VIEW;
        onServiceCostsModalChange(event);
        this.setState({
            isServiceCostsModalOpen: !this.state.isServiceCostsModalOpen,
        });
    }

    buildServiceCostsModal(productCost, investmentType) {
        const calculateValue = this.calculateValue();
        const title = (
            <FormattedText value="raHireManagementPlanStep1-raHireManagementPlanStep1_serviceCostsHeader" />
        );
        const content =
            investmentType === RA_INVESTMENT_TYPE_MONEY ? (
                <div>
                    <FormattedText
                        className="ra-hire-management-plan-step1--block"
                        value="raHireManagementPlanStep1-raHireManagementPlanStep1_fullCostDetails"
                    />
                    <div className="ra-hire-management-plan-step1__text-container">
                        <FormattedText value="raHireManagementPlanStep1-servicesCostModal" />{' '}
                        <span className="ra-hire-management-plan-step1--bold">
                            <FormattedText
                                value="raHireManagementPlanStep1-additionalVat"
                                injectedStrings={[calculateValue]}
                            />
                        </span>
                    </div>
                    <div className="ra-hire-management-plan-step1__text-container">
                        <FormattedText value="raHireManagementPlanStep1-implicitcost1" />{' '}
                        <span className="ra-hire-management-plan-step1">
                            {productCost + ' ' + PERCENTAGE_SYMBOL}
                        </span>{' '}
                        <FormattedText value="raHireManagementPlanStep1-implicitcost2" />
                    </div>
                    <div className="ra-hire-management-plan-step1__text-container">
                        <FormattedText value="raHireManagementPlanStep1-productsCost" />{' '}
                        <span className="ra-hire-management-plan-step1">
                            {productCost + ' ' + PERCENTAGE_SYMBOL}
                        </span>
                    </div>
                </div>
            ) : (
                <div>
                    <FormattedText
                        className="ra-hire-management-plan-step1--block"
                        value="raHireManagementPlanStep1-raHireManagementPlanStep1_fullCostDetails"
                    />
                    <FormattedText
                        className="ra-hire-management-plan-step1--bold ra-hire-management-plan-step1--block"
                        value="raHireManagementPlanStep1-raHireManagementPlanStep1_serviceCosts"
                    />
                    <FormattedText value="raHireManagementPlanStep1-raHireManagementPlanStep1_explicitCost1" />{' '}
                    <FormattedText
                        className="ra-hire-management-plan-step1--bold ra-hire-management-plan-step1--block"
                        value="raHireManagementPlanStep1-raHireManagementPlanStep1_explicitCostValue"
                        injectedStrings={[
                            explicitCostValue1.value1,
                            explicitCostValue1.value2,
                        ]}
                    />
                    <FormattedText value="raHireManagementPlanStep1-raHireManagementPlanStep1_explicitCost2" />
                    <FormattedText
                        className="ra-hire-management-plan-step1--bold ra-hire-management-plan-step1--block"
                        value="raHireManagementPlanStep1-raHireManagementPlanStep1_explicitCostValue"
                        injectedStrings={[
                            explicitCostValue2.value1,
                            explicitCostValue2.value2,
                        ]}
                    />
                    <FormattedText value="raHireManagementPlanStep1-raHireManagementPlanStep1_explicitCost3" />
                    <FormattedText
                        className="ra-hire-management-plan-step1--bold ra-hire-management-plan-step1--block"
                        value="raHireManagementPlanStep1-raHireManagementPlanStep1_explicitCostValue"
                        injectedStrings={[
                            explicitCostValue3.value1,
                            explicitCostValue3.value2,
                        ]}
                    />
                    <FormattedText value="raHireManagementPlanStep1-raHireManagementPlanStep1_explicitCost4" />
                    <FormattedText
                        className="ra-hire-management-plan-step1--bold ra-hire-management-plan-step1--block"
                        value="raHireManagementPlanStep1-raHireManagementPlanStep1_explicitCostValue"
                        injectedStrings={[
                            explicitCostValue4.value1,
                            explicitCostValue4.value2,
                        ]}
                    />
                    <FormattedText value="raHireManagementPlanStep1-raHireManagementPlanStep1_explicitCost5" />
                    <FormattedText
                        className="ra-hire-management-plan-step1--bold ra-hire-management-plan-step1--block"
                        value="raHireManagementPlanStep1-raHireManagementPlanStep1_explicitCostValue"
                        injectedStrings={[
                            explicitCostValue5.value1,
                            explicitCostValue5.value2,
                        ]}
                    />
                    <div className="ra-hire-management-plan-step1__text-container">
                        <FormattedText value="raHireManagementPlanStep1-implicitcost1" />
                        <span className="ra-hire-management-plan-step1">
                            {productCost + ' ' + PERCENTAGE_SYMBOL}
                        </span>{' '}
                        <FormattedText value="raHireManagementPlanStep1-implicitcost2" />
                    </div>
                    <FormattedText
                        className="ra-hire-management-plan-step1--bold"
                        value="raHireManagementPlanStep1-productsCost"
                    />{' '}
                    <span className="ra-hire-management-plan-step1 ra-hire-management-plan-step1--bold">
                        {productCost + ' ' + PERCENTAGE_SYMBOL}
                    </span>
                </div>
            );
        return (
            <OKModal
                content={content}
                title={title}
                titleAlignment="center"
                footerType="action"
                contentOverflow="auto"
                isOpen={this.state.isServiceCostsModalOpen}
                onCloseCallback={this.handleServiceCostsModalToogle}
                onPrimaryButtonClick={this.handleServiceCostsModalConfirm}
                primaryButtonText={
                    'raHireManagementPlanStep1-raHireManagementPlanStep1_modalCTAButton'
                }
                shouldCloseOnOverlayClick={false}
            />
        );
    }

    buildHireFundsTable(
        showDetails = true,
        showFooterOnly = false,
        showAccountHeader = true,
    ) {
        const {
            availableAccountsWithFunds,
            accountOwner,
            fundsTotalAmount,
            immSteps,
            initialAmountSimulated,
            selectedAccountsWithFunds,
            updateSelectedAccountsWithFunds,
            updateSelectedFundsTotal,
        } = this.props;
        const selectedAccount = immSteps.getIn([FIRST_STEP, 'selectedAccount']);

        return (
            <div className="ra-hire-management-plan-step1__table">
                <RAHireFundTable
                    accountOwner={accountOwner}
                    availableAccountsWithFunds={availableAccountsWithFunds}
                    fundsTotalAmount={fundsTotalAmount}
                    selectedAccount={selectedAccount}
                    selectedAccountsWithFunds={selectedAccountsWithFunds}
                    updateSelectedAccountsWithFunds={
                        updateSelectedAccountsWithFunds
                    }
                    updateSelectedFundsTotal={updateSelectedFundsTotal}
                    simulationAmount={initialAmountSimulated}
                    showDetails={showDetails}
                    showFooterOnly={showFooterOnly}
                    showAccountHeader={showAccountHeader}
                />
            </div>
        );
    }

    handleTransferFundsMoreInfoModalToogle() {
        this.setState({
            isTransferFundsModalOpen: !this.state.isTransferFundsModalOpen,
        });
    }

    buildTransferFundsMoreInfoModal() {
        const modalContent = (
            <div>
                <FormattedText value="raHireManagementPlanStep1-raHireManagementPlanStep1_transferFundsInfoModalText" />
            </div>
        );
        return (
            <OKModal
                content={modalContent}
                isOpen={this.state.isTransferFundsModalOpen}
                onCloseCallback={this.handleTransferFundsMoreInfoModalToogle}
                shouldCloseOnOverlayClick={false}
            />
        );
    }

    buildFundsSelectionSection() {
        const { fundsTotalAmount, initialAmountSimulated } = this.props;
        const hireFundsTable = this.buildHireFundsTable();

        const initialAmountObject = {
            amount: initialAmountSimulated,
            currency: EURO_SYMBOL,
        };

        const amountSelectedObject = {
            amount: fundsTotalAmount,
            currency: EURO_SYMBOL,
        };
        const sufficientFundSelected = fundsTotalAmount >= MINIMUM_FUND_AMOUNT;
        const initialAmountFormatted = getFormattedString(initialAmountObject);
        const ccDescriptionBeforeFundSelecton = !sufficientFundSelected && (
            <ContactCenterRender>
                <BlockInfo extraClass="col-md-12 ra-hire-management-plan-step1__cc-message">
                    <FormattedText
                        value="cc_raHireManagementPlanStep1-description"
                        injectedStrings={[initialAmountFormatted]}
                    />
                </BlockInfo>
            </ContactCenterRender>
        );
        const amountSelectedObjectFormatted = getFormattedString(
            amountSelectedObject,
        );
        const ccDescriptionAfterFundSelecton = sufficientFundSelected && (
            <ContactCenterRender>
                <BlockInfo extraClass="col-md-12 ra-hire-management-plan-step1__cc-message">
                    <FormattedText
                        value="cc_raHireManagementPlanStep1-selectionSummary"
                        injectedStrings={[amountSelectedObjectFormatted]}
                    />
                </BlockInfo>
            </ContactCenterRender>
        );

        const label = formatText(
            `raHireManagementPlanStep1-raHireManagementPlanStep1_fundSelectionMoreInfoLinkLabel`,
        );

        const fundsSelectionMoreInfoLink = (
            <OKLink
                extraClass="ra-hire-management-plan-step1__more-info-link ra-hire-management-plan-step1--bold"
                onClick={this.handleTransferFundsMoreInfoModalToogle}
                modifier="emphasize"
            >
                {label}
            </OKLink>
        );

        return (
            <React.Fragment>
                <div className="col-md-12 ra-hire-management-plan-step1__funds-selection-container">
                    {ccDescriptionBeforeFundSelecton}
                    <div className="ra-hire-management-plan-step1__fund-selector-title">
                        <FormattedText value="raHireManagementPlanStep1-raHireManagementPlanStep1_foundsModalTitle" />
                    </div>
                    <FormattedTextWithComponents
                        value="raHireManagementPlanStep1-raHireManagementPlanStep1_fundSelectLabel"
                        injectedComponents={[fundsSelectionMoreInfoLink]}
                    />
                    <ContactCenterRender>
                        <BlockInfo extraClass="ra-hire-management-plan-step1__cc-message ra-hire-management-plan-step1__cc-message--first">
                            <FormattedText value="cc_raHireManagementPlanStep1-fundsModalDescription1" />
                        </BlockInfo>
                    </ContactCenterRender>
                    {hireFundsTable}
                </div>
                <div className="col-md-12 ra-hire-management-plan-step1__informative-message">
                    <WebappRender>
                        <OKMessage type="informative">
                            <FormattedText value="raHireManagementPlanStep1-raHireManagementPlanStep1_foundInformativeText" />
                        </OKMessage>
                    </WebappRender>
                </div>
                {ccDescriptionAfterFundSelecton}
            </React.Fragment>
        );
    }

    buildInvestmentMoneysection() {
        const { active, immSteps } = this.props;
        const investmentAmount = immSteps.getIn([
            FIRST_STEP,
            'investmentAmount',
        ]);
        const amountSectionBlock = this.buildAmountSection(
            investmentAmount,
            active,
        );
        return (
            <div className="col-md-3">
                <div className="ra-hire-management-plan-step1__col-header print-label">
                    <FormattedText
                        value="raHireManagementPlanStep1-investmentAmount"
                        className="ra-hire-management-plan-step1__col-header-inputheader"
                    />
                </div>
                <div>{amountSectionBlock}</div>
            </div>
        );
    }

    buildInvestmentFoundsSection() {
        const { hasFounds, active, fundsTotalAmount, immSteps } = this.props;
        let fundsSelectionSection;
        let content;
        let hasNoFundSection;

        if (active) {
            if (hasFounds) {
                fundsSelectionSection = this.buildFundsSelectionSection();
            } else {
                const amountObject = {
                    amount: MINIMUM_FUND_AMOUNT,
                    currency: EURO_SYMBOL,
                };
                const amountFormatted = getFormattedString(amountObject);
                hasNoFundSection = (
                    <div className="col-md-7 col-md-offset-1  ra-hire-management-plan-step1__investment-section">
                        <div className="col-md-12 ra-hire-management-plan-step1__investment-title">
                            <FormattedText value="raHireManagementPlanStep1-raHireManagementPlanStep1_foundsTitle" />
                        </div>
                        <WebappRender>
                            <div className="col-md-9">
                                <FormattedText value="raHireManagementPlanStep1-raHireManagementPlanStep1_description2" />
                            </div>
                        </WebappRender>
                        <ContactCenterRender>
                            <BlockInfo extraClass="ra-hire-management-plan-step1__cc-message">
                                <FormattedText
                                    value="cc_raHireManagementPlanStep1-notSufficientFunds"
                                    injectedStrings={[amountFormatted]}
                                />
                            </BlockInfo>
                        </ContactCenterRender>
                    </div>
                );
            }
            content = (
                <div>
                    {hasNoFundSection}
                    {fundsSelectionSection}
                </div>
            );
        } else {
            const amountObject = {
                amount: fundsTotalAmount,
                currency: EURO_SYMBOL,
            };
            const hireFundsTable = this.buildHireFundsTable(
                false,
                true,
                false,
                true,
            );
            const investmentType = immSteps.getIn([
                FIRST_STEP,
                'investmentType',
            ]);
            const investmentTypeMoneyClasses = classnames('col-md-3', {
                'no-print-out': investmentType === RA_INVESTMENT_TYPE_FOUNDS,
            });
            const investmentTypeFundClasses = classnames(
                'ra-hire-management-plan-step1__hidden-section',
                {
                    'no-print-out': investmentType === RA_INVESTMENT_TYPE_MONEY,
                },
            );

            content = (
                <React.Fragment>
                    <div className={investmentTypeMoneyClasses}>
                        <div className="ra-hire-management-plan-step1__col-header print-label">
                            <FormattedText
                                value="raHireManagementPlanStep1-investmentAmount"
                                className="ra-hire-management-plan-step1__col-header-inputheader"
                            />
                        </div>
                        <div>
                            <RAOneLineSymbolAmount
                                amountObject={amountObject}
                            />
                        </div>
                    </div>
                    <div className={investmentTypeFundClasses}>
                        <div className="print-label ra-hire-management-plan-step1__print-title">
                            <FormattedText value="cc_raHireManagementPlanStep1-fundsTitle" />
                        </div>
                        {hireFundsTable}
                    </div>
                </React.Fragment>
            );
        }

        return content;
    }

    render() {
        const {
            active,
            immSteps,
            productCost,
            enableHireWithTransfer,
        } = this.props;
        const productCostPerrcentage = formatAmount(
            formatWithoutRoundedPercentage(productCost, false, true),
        );
        const transferModal = this.buildTransferFundsMoreInfoModal();
        const investmentMoney = {
            value: RA_INVESTMENT_TYPE_MONEY,
            text: 'raHireManagementPlanStep1-raHireManagementPlanStep1_money',
        };
        const investmentFounds = {
            value: RA_INVESTMENT_TYPE_FOUNDS,
            text: 'raHireManagementPlanStep1-raHireManagementPlanStep1_founds',
        };
        const serviceCostLabel = (
            <div className="ra-hire-management-plan-step1__text--grey">
                <OKLink onClick={this.handleServiceCostsModalToogle}>
                    <FormattedText value="raHireManagementPlanStep1-raHireManagementPlanStep1_fundVariableLabel" />
                </OKLink>
            </div>
        );
        const investmentType = immSteps.getIn([FIRST_STEP, 'investmentType']);
        const investmentSection =
            investmentType === RA_INVESTMENT_TYPE_MONEY
                ? this.buildInvestmentMoneysection()
                : this.buildInvestmentFoundsSection();
        const serviceCostListBlock =
            investmentType === RA_INVESTMENT_TYPE_MONEY || !active
                ? this.buildServiceCostList()
                : serviceCostLabel;
        const costsModal = this.buildServiceCostsModal(
            productCostPerrcentage,
            investmentType,
        );
        const operationDescription = (
            <div className="ra-hire-management-plan-step1__operation-description">
                <FormattedText value="raHireManagementPlanStep1-raHireManagementPlanStep1_operationDescription" />
            </div>
        );
        const firstRow =
            enableHireWithTransfer && active ? (
                <div className="col-md-4 ra-hire-management-plan-step1__pills-container">
                    <OKPillSelectors
                        items={[investmentMoney, investmentFounds]}
                        onSelectionChange={this.handleChangeInvestmentType}
                        selectedValues={[investmentType]}
                        externalHandling={true}
                    />
                </div>
            ) : (
                investmentSection
            );

        const secondRow =
            enableHireWithTransfer && active ? (
                <div className="row">{investmentSection}</div>
            ) : null;

        return (
            <div className="ra-hire-management-plan-step1">
                {costsModal}
                {transferModal}
                {operationDescription}
                <div className="row">
                    {firstRow}
                    <div className="col-md-6">
                        <div className="ra-hire-management-plan-step1__list-items">
                            {serviceCostListBlock}
                        </div>
                    </div>
                    <div className="col-md-2" />
                </div>
                {secondRow}
            </div>
        );
    }
}

RAHireManagementPlanStep1.propTypes = {
    accountOwner: PropTypes.string,
    availableAccountsWithFunds: PropTypes.object.isRequired,
    active: PropTypes.bool.isRequired,
    changeInvestmentType: PropTypes.func.isRequired,
    commisionCondition: PropTypes.bool.isRequired,
    fundsTotalAmount: PropTypes.number,
    handleGetExplicitImplicitCosts: PropTypes.func,
    immSteps: PropTypes.object.isRequired,
    initialAmountSimulated: PropTypes.number.isRequired,
    onInvestmentAmountChange: PropTypes.func,
    onInvestmentTypeChange: PropTypes.func,
    showImplicitCost: PropTypes.bool,
    onServiceCostsModalChange: PropTypes.func,
    annualCost: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    productCost: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    updateSelectedAccountsWithFunds: PropTypes.func,
    updateSelectedFundsTotal: PropTypes.func,
    enableHireWithTransfer: PropTypes.bool,
    hasFounds: PropTypes.bool,
    changeTransferFundsAccount: PropTypes.func,
    immAccounts: PropTypes.object,
    selectedAccountsWithFunds: PropTypes.object,
    setSelectedAccount: PropTypes.func,
};

RAHireManagementPlanStep1.defaultProps = {
    onInvestmentAmountChange: () => {},
    onInvestmentTypeChange: () => {},
    onServiceCostsModalChange: () => {},
};

module.exports = RAHireManagementPlanStep1;
